import { GatewayChat } from "./GatewayChat"

export type ChatMessage = {
  messageType: "Question" | "Response" | "Error"
  text: string
}

export const AIChat = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) => <GatewayChat isOpen={isOpen} onClose={onClose} />
